'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialVimeo = function TiSocialVimeo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.5 14.6c-0.5 3.2-2 6.3-4.4 9.2-2.4 2.8-4.5 4.9-6.3 6.1-1.2 0.6-2.2 0.6-3 0.1-0.8-0.5-1.5-1.3-2-2.2-0.2-0.6-0.9-2.6-2-6.2-1-3.6-1.7-5.6-1.9-5.8-0.1-0.3-0.5-0.4-1-0.1-0.6 0.2-0.9 0.3-1.1 0.5-0.2 0.1-0.4 0.2-0.5 0.4l-1-1.3 1.1-1.2c0.7-0.8 1.7-1.7 2.8-2.6 1.2-0.8 2.2-1.4 3.1-1.6 0.6-0.1 1.1 0 1.6 0.3 0.4 0.3 0.7 0.8 1 1.5 0.3 0.6 0.5 1.3 0.6 1.9 0.1 0.7 0.3 1.5 0.4 2.4 0.1 0.9 0.3 1.5 0.4 2 0.8 3.2 1.4 4.8 1.9 4.8 0.7 0 1.7-1.4 3.3-4.3 0.6-1.3 0.7-2.4 0.1-3.2-0.7-0.9-1.6-0.9-2.9-0.1 0.2-1.3 0.8-2.4 1.7-3.3 1.7-1.9 3.6-2.6 5.7-2.1 2.1 0.4 2.9 2 2.4 4.8z' })
        )
    );
};

exports.default = TiSocialVimeo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-vimeo.js
// module id = 3970
// module chunks = 0